export const ProjectsComponent = () => {
    const projects = [
        {
            title: "Portfolio Website",
            description: "This website itself, built from scratch.",
            tech: "React, Material UI, CSS",
            liveLink: "https://prakash-tiwari.netlify.app/portfolio-redesign"
        },
        {
            title: "Books Exchange Application",
            description: "Book trading platform for students.",
            tech: "React, Redux, JAVA, MongoDB",
            liveLink: "https://books-exchange.netlify.app/"
        },
        {
            title: "Personality Compatibility - Survey App",
            description: "Used by 175+ nursing students.",
            tech: "React, Redux, JAVA, Springboot, MongoDb",
            liveLink: "https://personality-compatibility.netlify.app/"
        },
        {
            title: "LinkedIn Clone",
            description: "A clone of linked in",
            tech: "React, Redux, Firebase",
            liveLink: "https://prakash-tiwari.netlify.app/clones"
        },
        {
            title: "Daily Spend",
            description: "Track daily expenses with clean UI and insights.",
            tech: "Android (Java)",
            liveLink: "https://www.amazon.com/Prakash-Daily-spend/dp/B087XSKM7H/"
        },
        {
            title: "Women Safe - Android App",
            description: "A safety-focused application for women.",
            tech: "Android",
            liveLink: "https://www.amazon.com/Prakash-Women-safe/dp/B088TWG51M/"
        },
        {
            title: "Help Me - Android App",
            description: "Emergency assistance app for quick help.",
            tech: "Android",
            liveLink: "https://www.amazon.com/Prakash-Help-me/dp/B089136D3J/"
        },
        {
            title: "Lend and Borrow",
            description: "Track borrowed or lent items easily.",
            tech: "Android (Java)",
            liveLink: "https://www.amazon.com/Prakash-Lend-and-Borrow/dp/B08BK2YWQP/"
        }
    ];

    const scroll = (direction) => {
        const container = document.querySelector(".projects-scroll-container");
        const scrollAmount = 350;

        if (direction === "left") {
            container.scrollBy({ left: -scrollAmount, behavior: "smooth" });
        } else {
            container.scrollBy({ left: scrollAmount, behavior: "smooth" });
        }
    };

    return (
        <div className="projects-section" id={'projects-section'}>
            <button className="scroll-btn left" onClick={() => scroll("left")}>◀</button>
            <button className="scroll-btn right" onClick={() => scroll("right")}>▶</button>

            <div className="projects-scroll-container">
                {projects.map((p, index) => (
                    <div className="project-card" key={index}>
                        <span className="live-badge">LIVE</span>
                        <h3>{p.title}</h3>
                        <p className="project-desc">{p.description}</p>
                        <br/>
                        <div className="tech-stack">
                            <p>{p.tech}</p>
                        </div>

                        <a href={p.liveLink} target="_blank" rel="noopener noreferrer" className="project-link">
                            Visit Project →
                        </a>
                    </div>
                ))}
            </div>
        </div>
    );
};
